export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <i className="ri-truck-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Man & Van Services Ltd</h3>
                <p className="text-xs text-blue-400">Professional Moving Service</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner for house removals, office moves, and single item collections across London and beyond.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('coverage')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Coverage Area
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">House Removals</li>
              <li className="text-gray-400">Office Moves</li>
              <li className="text-gray-400">Single Item Collections</li>
              <li className="text-gray-400">Cleaning Services</li>
              <li className="text-gray-400">Commercial Waste Collection</li>
              <li className="text-gray-400">End of Tenancy Clearance</li>
              <li className="text-gray-400">Handyman Service</li>
              <li className="text-gray-400">Storage Solutions</li>
              <li className="text-gray-400">Packing Services</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-blue-400 text-xl mt-1"></i>
                <div>
                  <a href="tel:+447380118450" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    07380 118 450
                  </a>
                  <p className="text-sm text-gray-500">24/7 Available</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-blue-400 text-xl mt-1"></i>
                <a href="mailto:info@manvanservices.org" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  info@manvanservices.org
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-blue-400 text-xl mt-1"></i>
                <div className="text-gray-400">
                  <div className="mb-3">
                    <p className="text-blue-400 font-semibold mb-1">London Office</p>
                    <p>
                      71-75 Shelton Street, Covent Garden<br />
                      London, United Kingdom<br />
                      WC2H 9JQ
                    </p>
                  </div>
                  <div>
                    <p className="text-blue-400 font-semibold mb-1">Essex Office</p>
                    <p>
                      Trafalgar House<br />
                      712 London Road<br />
                      West Thurrock<br />
                      RM20 3JT<br />
                      United Kingdom
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-gray-400 text-sm">
              Man & Van Services Ltd. Registered in England No.16862979.<br />
              © 2025. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
